const expand = document.querySelectorAll('[data-behaviour="toggle"]');
expand.forEach((el) => {
    el.addEventListener('click', function(e) {
        e.preventDefault();
        e.target.closest('.toggle').classList.toggle('open');
    });
});

const rowToggle = document.querySelectorAll('[data-behaviour="row-toggle"]');
rowToggle.forEach((el) => {
    el.addEventListener('click', function(e) {
        e.preventDefault();

        let toggle = el;
        if( !e.target.classList.contains('button') ) {
            toggle = e.target.closest('[data-behaviour="row-toggle"]');
        }

        let id = toggle.dataset.id;

        let showLabel = toggle.querySelector('[data-behaviour="row-toggle-show"]');
        let hideLabel = toggle.querySelector('[data-behaviour="row-toggle-hide"]');
        
        if(showLabel) {
            showLabel.classList.toggle('u-hidden');
        }

        if(hideLabel) {
            hideLabel.classList.toggle('u-hidden');
        }
        
        let row = document.querySelector(`#toggle-row-${id}`);
        if( row ) {
            row.classList.toggle('u-hidden');
        }
    });
});